import React from "react";
import Marquee from "react-fast-marquee";
import { firstTrustedBrands } from "./trustedBrands";
import { secondTrustedBrands } from "./trustedBrands";


export default function TrustedBrandsCopy() {
  return (
    <>
      <Marquee gradient={true} gradientWidth={20} className="mt-10">
        {firstTrustedBrands.map((brand, index) => (
          <span key={index} className="h-[40px] w-auto object-contain">
            <img
              src={brand.src}
              className="h-[40px] w-auto mx-8 object-contain"
              alt="Trusted Brand"
            />
          </span>
        ))}
      </Marquee>

      <Marquee
        gradient={true}
        gradientWidth={20}
        direction="right"
        className="mt-10  mx-auto  w-[88%]"
      >
        {secondTrustedBrands.map((brand, index) => (
          <span key={index} className="h-[40px] w-auto object-contain">
            <img
              src={brand.src}
              className="h-[40px] w-auto mx-8 object-contain"
              alt="Trusted Brand"
            />
          </span>
        ))}
      </Marquee>
    </>
  );
}
